import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import AllPackageFilter from "./VisitorComp/AllPackageFilter";
import { baseurl, imageUrl } from "../../component/Baseurl";
import logo from "../../component/img/logo3.jpg";

function AllPackages() {
  const [packages, setPackages] = useState([]);
  const [filteredPackages, setFilteredPackages] = useState([]);
  const [packageSearchTerm, setPackageSearchTerm] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await axios.get(`${baseurl}GetAllPackages`);
        if (response.data.packages) {
          setPackages(response.data.packages);
          setFilteredPackages(response.data.packages);
        }
      } catch (error) {
        console.error("Error fetching packages:", error);
      }
    };

    fetchPackages();
  }, []);

  // Filter Function
  useEffect(() => {
    let filtered = packages;

    // Package Name Filter
    if (packageSearchTerm) {
      filtered = filtered.filter(pkg =>
        pkg.package_name.toLowerCase().includes(packageSearchTerm.toLowerCase())
      );
    }

    // Price Filter
    if (minPrice || maxPrice) {
      filtered = filtered.filter(pkg => {
        const price = parseFloat(pkg.price);
        return (!minPrice || price >= parseFloat(minPrice)) &&
               (!maxPrice || price <= parseFloat(maxPrice));
      });
    }

    setFilteredPackages(filtered);
  }, [packageSearchTerm, minPrice, maxPrice, packages]);

  return (
    <>
      <section className="bgmig1">
        <Navbar />

        <section className="hot-page2-alp hot-page2-pa-sp-top">
          <div className="container">
            <div className="row inner_banner bg-none">
              <div className="hot-page2-alp-tit">
                <h1>Travel Packages</h1>
                <div className="title-line">
                  <div className="tl-1"></div>
                  <div className="tl-2"></div>
                  <div className="tl-3"></div>
                </div>
                <p>World's leading Hotel Booking website, Over 30,000 Hotel rooms worldwide.</p>
                <ul>
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <i className="fa fa-angle-right" aria-hidden="true"></i>
                  </li>
                  <li>
                    <a href="#" className="bread-acti">All Packages</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="row p-1 ms-3">
              <div className="hot-page2-alp-con row">
                {/* Left Sidebar Filter */}
                <div className="col-md-3">
                  <div className="filter-box text-start">
                    <h4 className="mb-3">Filter Packages</h4>

                    {/* Package Name Search */}
                    <div className="form-group mb-3">
                      <label className="text-dark mb-1 labelset2 font3">Search Package</label>
                      <input
                        type="text"
                        className="input1"
                        placeholder="Search by name"
                        value={packageSearchTerm}
                        onChange={(e) => setPackageSearchTerm(e.target.value)}
                      />
                    </div>

                    {/* Price Range Filter */}
                    <div className="form-group mb-3">
                      <label className="text-dark mb-1 labelset2 font3">Min Price</label>
                      <input
                        type="number"
                        className="input1"
                        placeholder="Min Price"
                        value={minPrice}
                        onChange={(e) => setMinPrice(e.target.value)}
                      />
                    </div>

                    <div className="form-group mb-3">
                      <label className="text-dark mb-1 labelset2 font3">Max Price</label>
                      <input
                        type="number"
                        className="input1"
                        placeholder="Max Price"
                        value={maxPrice}
                        onChange={(e) => setMaxPrice(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                {/* Right Side - Package List */}
                <div className="col-md-9 hot-page2-alp-con-right">
                  {filteredPackages.length > 0 ? (
                    filteredPackages.map((pkg) => (
                      <div className="hot-page2-alp-con-right-1" key={pkg.id}>
                        <div className="row hot-page2-alp-r-list">

                          {/* Package Image */}
                          <div className="col-md-3 hot-page2-alp-r-list-re-sp">
                            <a href={`/package-detail/${pkg.slug}`}>
                              <div className="hot-page2-hli-1">
                                <img
                                  src={pkg.banner_image ? `${imageUrl}packages/${pkg.banner_image}` : logo}
                                  alt={pkg.package_name}
                                  className="img-fluid"
                                />
                              </div>
                            </a>
                          </div>

                          {/* Package Details */}
                          <div className="col-md-6">
                            <div className="trav-list-bod">
                              <a href={`/package-detail/${pkg.slug}`}>
                                <h3 className="text-start kai2">{pkg.package_name}</h3>
                              </a>
                              <p className="text-start">{pkg.package_description}</p>
                            </div>
                          </div>

                          {/* Package Price & Booking */}
                          <div className="col-md-3">
                            <div className="hot-page2-alp-ri-p3 tour-alp-ri-p3">
                              <span className="hot-list-p3-1">Starting From</span>
                              <span className="hot-list-p3-2">₹{pkg.price}</span>
                              <span className="hot-list-p3-4">
                                <a href={`/package-detail/${pkg.slug}`} className="hot-page2-alp-quot-btn">Book Now</a>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No packages found.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </section>
    </>
  );
}

export default AllPackages;
